// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3b3hf","validationTips":"StatementDescriptor_validationTips__bsP1U"};